export default "__VITE_ASSET__vukacSWB__"